module.exports = __webpack_public_path__ + "static/media/cha-bbobi-name.9c89c0f8.svg";